module.exports = __webpack_public_path__ + "static/img/pig.abd6a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/year/pig.png
// module id = 9TnQ
// module chunks = 1